import { SellableDto } from '../../products/store/sellable/Sellable';
import Sellables from '../../products/store/sellable/Sellables';
import Bundle from './Bundle';

export default class Bundles extends Sellables<Bundle> {
  itemName = 'bundle';

  protected unserialize(dto: SellableDto): Bundle {
    return new Bundle(dto);
  }
}
